import DateTimePickerComponent from "../components/DatePicker";
import EnumInput from "../components/EnumInput";
import CloseIcon from '@mui/icons-material/Close';
import { Reminder } from "./FrontendTypes";

type props =  {
    reminder: Reminder;
    setReminder: (reminder: Reminder) => void;
    deleteSelf: () => void;
}

enum Importance {
    IMPORTANT = "Wichtige",
    REGULAR = "Normale"
}

const ReminderConfigurer: React.FC<props> = ({reminder, setReminder, deleteSelf}: props) => {
    const handleDateChange = (date: Date) => {
        setReminder({...reminder, date});
    };

    const handleImportanceChange = (newImportance: Importance) => {
        setReminder({ ...reminder, urgent: newImportance === Importance.IMPORTANT });
    };

    return (
        <div className="reminder-configurer">
            <button className='remove-trip button-transparent' onClick={deleteSelf}>
                <CloseIcon/>
            </button>
            <EnumInput
                enumType={Importance}
                value={reminder.urgent ? Importance.IMPORTANT : Importance.REGULAR}
                onChange={(clickedImportance) => handleImportanceChange(clickedImportance)}
            />
            Benachrichtigung am
            <DateTimePickerComponent date={reminder.date} setDate={handleDateChange}/>
        </div>
    );
}

function createReminder(): Reminder {
    return {
        date: new Date(),
        urgent: false
    }
}
export { ReminderConfigurer as default, createReminder, type Reminder };
